import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { Devices } from "../../DeviceAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
import { TrackType } from "../../timeline/TrackType";
export class VaporisateurDeviceBoxAdapter {
    type = "instrument";
    accepts = "midi";
    #context;
    #box;
    #parametric;
    namedParameter; // let typescript infer the type
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#parametric = new ParameterAdapterSet(this.#context);
        this.namedParameter = this.#wrapParameters(box);
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get labelField() { return this.#box.label; }
    get iconField() { return this.#box.icon; }
    get defaultTrackType() { return TrackType.Notes; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get acceptsMidiEvents() { return true; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { this.#parametric.terminate(); }
    #wrapParameters(box) {
        return {
            volume: this.#parametric.createParameter(box.volume, ValueMapping.DefaultDecibel, StringMapping.numeric({ unit: "db", fractionDigits: 1 }), "volume"),
            octave: this.#parametric.createParameter(box.octave, ValueMapping.linearInteger(-3, 3), StringMapping.numeric(), "octave", 0.5),
            tune: this.#parametric.createParameter(box.tune, ValueMapping.linear(-1200.0, +1200.0), StringMapping.numeric({ unit: "cent", fractionDigits: 0 }), "tune", 0.5),
            waveform: this.#parametric.createParameter(box.waveform, ValueMapping.linearInteger(0, 3), StringMapping.indices("", ["sine", "triangle", "sawtooth", "square"]), "waveform"),
            cutoff: this.#parametric.createParameter(box.cutoff, ValueMapping.exponential(20.0, 18_000.0), StringMapping.numeric({ unit: "Hz" }), "cutoff"),
            resonance: this.#parametric.createParameter(box.resonance, ValueMapping.exponential(0.01, 10.0), StringMapping.numeric({ unit: "q", fractionDigits: 3 }), "resonance"),
            attack: this.#parametric.createParameter(box.attack, ValueMapping.exponential(0.001, 1.0), StringMapping.numeric({ unit: "s", fractionDigits: 3 }), "attack"),
            release: this.#parametric.createParameter(box.release, ValueMapping.exponential(0.001, 1.0), StringMapping.numeric({ unit: "s", fractionDigits: 3 }), "release"),
            filterEnvelope: this.#parametric.createParameter(box.filterEnvelope, ValueMapping.linear(-0.5, 0.5), StringMapping.percent(), "filter env", 0.5)
        };
    }
}
